import { TransitionPageComponent } from './pages/transition-page/transition-page.component';
import { ModalWrapperComponent } from './pages/home/components/modal-wrapper/modal-wrapper.component';
import { EngagementListComponent } from './pages/home/components/engagement-list/engagement-list.component';
import { MeetingActionsModalComponent } from './components/meeting-actions-modal/meeting-actions-modal.component';
import { GovernanceMeetingComponent } from './pages/governance-meetings/governance-meetings.component';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { MsalRedirectComponent } from '@azure/msal-angular';
import { environment } from 'src/environments/environment';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {
  MotifAvatarModule,
  MotifButtonModule,
  MotifCardModule,
  MotifDropdownModule,
  MotifHeaderModule,
  MotifIconModule,
  MotifModalModule,
  MotifProgressBarModule,
  MotifToastModule,
  MotifVerticalNavigationModule,
  MotifProgressLoaderModule,
  MotifAccordionModule,
  MotifTableModule,
  MotifTooltipModule,
  MotifFormsModule,
  MotifContentSwitcherModule
} from '@ey-xd/ng-motif';
import { PowerBIEmbedModule, PowerBIReportEmbedComponent } from 'powerbi-client-angular';
import { HeaderComponent } from './components/header/header.component';
import { MenuComponent } from './components/menu/menu.component';
import { HomeComponent } from './pages/home/home.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { LogoutComponent } from './pages/logout/logout.component';
import { AuthenticationModule } from './modules/authentication/authentication.module';
import { SessionExpiredComponent } from './pages/session-expired/session-expired.component';
import {
  SessionExpiryWarningModal,
  SessionExpiryWarningComponent,
} from './components/session-expiry-warning/session-expiry-warning.component';
import { ToastComponent } from './components/toast/toast.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BreadcrumbModule } from './components/breadcrumb/breadcrumb.module';
import { FormsModule } from '@angular/forms';
import { MainHeaderComponent } from './components/main-header/main-header.component';
import { ProgressTreeComponent } from './pages/home/components/progress-tree/progress-tree.component';
import { EngagementSummaryComponent } from './pages/home/components/engagement-summary/engagement-summary.component';
import { KeyHighlightsComponent } from './pages/home/components/key-highlights/key-highlights.component';
import { MeetingsComponent } from './pages/home/components/meetings/meetings.component';
import { InnovationProductivityComponent } from './pages/home/components/innovation-productivity/innovation-productivity.component';
import { TestimonialComponent } from './pages/home/components/testimonial/testimonial.component';
import { QuickLinkComponent } from './pages/home/components/quick-link/quick-link.component';
import { RiskManagementComponent } from './pages/home/components/risk-management/risk-management.component';
import { CommonExpandLayoutComponent } from './pages/home/components/common-expand-layout/common-expand-layout.component';
import { DonutPercentageChartComponent } from './pages/home/components/donut-percentage-chart/donut-percentage-chart.component';
import { BillableHoursComponent } from './pages/home/components/billable-hours/billable-hours.component';
import { SlaComplianceComponent } from './pages/home/components/sla-compliance/sla-compliance.component';
import { DonutChartComponent } from './pages/home/components/donut-chart/donut-chart.component';
import { TalentManagementComponent } from './pages/home/components/talent-management/talent-management.component';
import { TeamUtilizationComponent } from './pages/home/components/team-utilization/team-utilization.component';
import { MultiColorProgressBarComponent } from './pages/home/components/multi-color-progress-bar/multi-color-progress-bar.component';
import { GroupedBarChartComponent } from './pages/home/components/grouped-bar-chart/grouped-bar-chart.component';
import { SatisfactionGraphComponent } from './pages/home/components/satisfaction-graph/satisfaction-graph.component';
import { RevenueMarginChartComponent } from './pages/home/components/revenue-margin-chart/revenue-margin-chart.component';
import { InvoiceStatusComponent } from './pages/home/components/invoice-status/invoice-status.component';
import { LandingComponent } from './pages/landing/landing.component';
import { CardComponent } from './pages/landing/components/card/card.component';
import { PromotionProgressionComponent } from './pages/home/components/promotion-progression/promotion-progression.component';
import { HiringAttritionComponent } from './pages/home/components/hiring-attrition/hiring-attrition.component';
import { TrainingCertificationComponent } from './pages/home/components/training-certification/training-certification.component';
import { RevenuePotentialComponent } from './pages/home/components/revenue-potential/revenue-potential.component';
import { LoaderComponent } from './components/loader/loader.component';
import { ErrorViewComponent } from './components/error-view/error-view.component';
import { EngagementDetailsComponent } from './pages/engagement-details/engagement-details.component';
import { CarouselModule } from "ngx-owl-carousel-o";
import { LineProjectionChartModule } from "./modules/line-projection-chart/line-projection-chart.module";
import { AccessDeniedComponent } from './pages/access-denied/access-denied.component';
import { AssetLibraryComponent } from './pages/asset-library/asset-library.component';
import { ContractualDocsComponent } from './pages/contractual-docs/contractual-docs.component';
import { StackedChartModule } from './modules/stacked-chart/stacked-chart.module';
import { MeetingCardComponent } from './components/meeting-card/meeting-card.component';
import { MeetingDetailsModalComponent } from './components/meeting-details-modal/meeting-details-modal.component';
import { CaseStudiesComponent } from './pages/home/components/case-studies/case-studies.component';
import { InnovationProductivityPageComponent } from './pages/innovation-productivity-page/innovation-productivity-page.component';
import { MSChatComponent } from './components/ms-chat/ms-chat.component';
import { KeyMetricsComponent } from './components/key-metrics/key-metrics.component';
import { TransitionComponent } from './pages/home/components/transition/transition.component';
import { ActionDetailsModalComponent } from './components/action-details-modal/action-details-modal.component';
import { PowerBiDashboardComponent } from './pages/dashboard/powerbi.dashboard.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    MenuComponent,
    HomeComponent,
    ToastComponent,
    PageNotFoundComponent,
    LogoutComponent,
    SessionExpiredComponent,
    SessionExpiryWarningComponent,
    SessionExpiryWarningModal,
    MainHeaderComponent,
    ProgressTreeComponent,
    EngagementSummaryComponent,
    EngagementListComponent,
    KeyHighlightsComponent,
    MeetingsComponent,
    MeetingCardComponent,
    MeetingDetailsModalComponent,
    MeetingActionsModalComponent,
    InnovationProductivityComponent,
    TestimonialComponent,
    CaseStudiesComponent,
    QuickLinkComponent,
    RiskManagementComponent,
    CommonExpandLayoutComponent,
    DonutPercentageChartComponent,
    BillableHoursComponent,
    SlaComplianceComponent,
    DonutChartComponent,
    TalentManagementComponent,
    TeamUtilizationComponent,
    MultiColorProgressBarComponent,
    GroupedBarChartComponent,
    SatisfactionGraphComponent,
    RevenueMarginChartComponent,
    InvoiceStatusComponent,
    LandingComponent,
    CardComponent,
    PromotionProgressionComponent,
    HiringAttritionComponent,
    TrainingCertificationComponent,
    RevenuePotentialComponent,
    LoaderComponent,
    ErrorViewComponent,
    EngagementDetailsComponent,
    AccessDeniedComponent,
    AssetLibraryComponent,
    GovernanceMeetingComponent,
    ContractualDocsComponent,
    InnovationProductivityPageComponent,
    MSChatComponent,
    KeyMetricsComponent,
    TransitionComponent,
    ModalWrapperComponent,
    TransitionPageComponent,
    ActionDetailsModalComponent,
    PowerBiDashboardComponent,
],
  imports: [
    HttpClientModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    PowerBIEmbedModule,
    MotifToastModule,
    MotifCardModule,
    MotifIconModule,
    MotifHeaderModule,
    MotifAvatarModule,
    MotifVerticalNavigationModule,
    MotifButtonModule,
    MotifDropdownModule,
    MotifModalModule,
    BreadcrumbModule,
    MotifProgressLoaderModule,
    MotifAccordionModule,
    MotifTableModule,
    MotifTooltipModule,
    MotifFormsModule,
    AuthenticationModule.forRoot(environment.authConfig),
    FormsModule,
    MotifProgressBarModule,
    CarouselModule,
    LineProjectionChartModule,
    StackedChartModule,
    MotifContentSwitcherModule,
  ],
  providers: [],
  bootstrap: [AppComponent, MsalRedirectComponent],  
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AppModule {}
